/**
 * @file Init redux store.
 */

import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import createRootReducer from '../reducers/root-reducer';

const getReduxStore = initialState => {
  /* eslint-disable no-underscore-dangle */
  const composeEnhancers =
    window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;
  /* eslint-enable */

  const store = createStore(
    createRootReducer(),
    initialState,
    composeEnhancers(applyMiddleware(thunk)),
  );

  if (module.hot) {
    module.hot.accept('../reducers/root-reducer', () => {
      const nextRootReducer = require('../reducers/root-reducer').default;
      store.replaceReducer(nextRootReducer());
    });
  }

  return store;
};

export default getReduxStore;
